import React from "react";

// Default components
import {defaultComponents} from "./../components/_default/interfaces/DefaultComponents"
import ContentRenderer from "./../components/_default/ContentRenderer"
import MetadataComponent from "./../components/_default/MetadataComponent";
import CheckNotFoundPage from "./../components/_default/CheckNotFoundPage";
import { useAppSelector, useAppDispatch } from "./../store/hooks"

window.defaultComponents = defaultComponents;

export default function Webpage479russian_test_2() {
        const page_seo = {
                    seo_title: 'russian-test-2 - testprana.itpr.eu',
                    canonical: 'https:\/\/testprana.itpr.eu\/et',
            }
    
    const dispatch = useAppDispatch();
    
    React.useEffect(() => {
        dispatch({
            type: "SET_WEBPAGE_ACTIVE",
            payload: "019c89f4-e21d-7ce8-906d-4ec4353a9f11"
        });
    }, [])
    
    React.useEffect(() => {
        dispatch({
            type: "UPDATE_STRUCTURE",
            payload: {"webpageComponents":[11722],"components":{"11722":{"id":11722,"uuid":"019c7a2d-7b89-7e25-b621-368aee742445","language_id":null,"parent_id":null,"webpage_id":479,"type":"section","sort_order":0,"version":1,"isShared":false,"attributes":{"classes":"row","content_width_unit":"%","content_width_size":100,"styles":{"paddingTop":"60px","paddingLeft":"60px","paddingRight":"60px","paddingBottom":"60px"}},"childWebpageComponentRelations":[]}}}        });
    }, [])
    
    
    
    return (
        <>
            <CheckNotFoundPage/>
            <MetadataComponent page_seo={page_seo} />
            <ContentRenderer />
        </>
    );
}